/**
 * @param {string} className
 * @param {boolean} value
 */
const setBodyClassEnabled = (className, value) => {
    if (value) {
        document.body.classList.add(className);
    } else {
        document.body.classList.remove(className);
    }
};

/**
 * @param {boolean} value
 */
const setLoggedInBodyClass = (value) => {
    setBodyClassEnabled('logged-in', value);
};

/**
 * @param {boolean} value
 */
const setHiddenNavBodyClass = (value) => {
    setBodyClassEnabled('hidden-nav', value);
};

/**
 * @returns {boolean}
 */
const navBarIsHidden = () => {
    return document.body.classList.contains('hidden-nav');
};

/**
 * @param {boolean} value
 */
const setBottomBarVisibleBodyClass = (value) => {
    setBodyClassEnabled('bottom-bar-visible', value);
};

module.exports = {
    navBarIsHidden,
    setBottomBarVisibleBodyClass,
    setLoggedInBodyClass,
    setHiddenNavBodyClass,
};
